import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    let last = false;

    const toggleVisibility = () => {
      const next = window.pageYOffset > 300;
      if (next !== last) {
        last = next;
        setIsVisible(next);
      }
    };

    // Passively update visibility to keep scroll performance smooth.
    window.addEventListener("scroll", toggleVisibility, { passive: true });
    toggleVisibility();

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (!isVisible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 bg-accent-green text-primary-text px-0 py-0 md:px-4 md:py-2 rounded-full lg:rounded-button shadow-lg hover:bg-accent-greenDark hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300 ease-out z-40 flex items-center justify-center space-x-0 lg:space-x-2 w-12 h-12 md:w-auto md:h-auto animate-[scrollTopIn_0.3s_ease-out]"
      aria-label="Scroll to top"
    >
      <span className="hidden lg:inline font-bold">Scroll to Top</span>
      <svg
        className="w-6 h-6 md:w-5 md:h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 10l7-7m0 0l7 7m-7-7v18"
        />
      </svg>
    </button>
  );
};
